module.exports = __webpack_public_path__ + "static/img/ayo.751571c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ayo.png
// module id = saCp
// module chunks = 1